<template>
  <datepicker
    :language="ptBR"
    format="dd/MM/yyyy"
    @input="onChange"
    ref="datepicker"
    :disabled-dates="disabledDates"
  ></datepicker>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { ptBR } from "vuejs-datepicker/dist/locale";

export default {
  components: {
    Datepicker,
  },
  props: {
    name: {
      required: false,
    },
    inputClass: {
      required: false,
    },
    disabledDates: {
      required: false,
    },
  },
  data: () => ({
    ptBR: ptBR,
    isPublicPage: false,
  }),
  methods: {
    onChange(ev) {
      this.$emit("input", moment(ev).format("DD/MM/YYYY"));
      this.$emit("change", moment(ev).format("DD/MM/YYYY"));
    },
  },
  mounted() {
    if (this.inputClass) {
      const input = this.$refs.datepicker.$el.querySelector(
        "input[type='text']"
      );
      input.classList.add(this.inputClass);
    }

    this.isPublicPage = !document.querySelector("#menu");
  },
};
</script>
<style lang="scss" scoped>
/deep/ {
  input[type="text"] {
    padding: 4px;
    border: 1px solid #cccccc;
    background: white;
    height: 27px;
    border-radius: 3px;
    pointer-events: auto;
    touch-action: auto;
  }

  .public-page {
    input[type="text"] {
      margin-top: 5px;
      font-size: 13px;
      color: #485156;
      padding: 8px;
      border: 1px solid #707070;
      height: 33px;
      position: relative;
    }

    .vdp-datepicker__calendar .cell.day-header {
      font-size: 13px;
      font-weight: bold;
    }
  }
}

@media only screen and (max-width: 768px) {
  /deep/ .vdp-datepicker__calendar {
    width: 110%;
  }

  /deep/ .vdp-datepicker__calendar .cell {
    height: 35px;
    line-height: 35px;
  }
}
</style>
